export default __webpack_public_path__ + "static/media/221111_notice01_221006.db962d0f.pdf";